module.exports = __webpack_public_path__ + "static/media/mainimg-14.73b294a6.png";